import { Component, input } from '@angular/core';
import { TransportListIconName } from '../../../../../../../../../../../../../../interfaces/custom-route.response';

@Component({
  selector: 'app-line',
  standalone: true,
  imports: [],
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.scss'],
})
export class LineComponent {
  public iconName = input<TransportListIconName>();
}
